'use client'

import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { Drawer, DrawerBody } from '@/ui/drawer/drawer/Drawer.client'
import { useAtom } from 'jotai'
import type React from 'react'
import sanitizeHtml from 'sanitize-html'
import { legalNoticeDrawerAtom } from '../../services/coupon.store'

function ViewLegalNoticeDrawer(): React.ReactElement {
  const [legalNoticeDrawerAtomState, setLegalNoticeDrawerAtomState] = useAtom(legalNoticeDrawerAtom)
  const { t } = useTranslation(['viewLegalNoticeDrawer'])

  const closeDrawer = (open: boolean) => {
    setLegalNoticeDrawerAtomState({ isOpen: open, content: legalNoticeDrawerAtomState.content })
  }

  return (
    <Drawer
      isOpen={legalNoticeDrawerAtomState.isOpen}
      onOpenChange={closeDrawer}
      title={t('viewLegalNoticeDrawer:title')}
    >
      <DrawerBody>
        <span
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(legalNoticeDrawerAtomState.content),
          }}
        />
      </DrawerBody>
    </Drawer>
  )
}

export default ViewLegalNoticeDrawer
